module.exports = __webpack_public_path__ + "static/media/2.579b8ed1.png";